import { z } from 'zod'
import { api } from '..'

const unresolvedAlertsResponseSchema = z.object({
  totalResults: z.number(),
})

export const hasUnresolvedAlerts = async (alertRuleId: string) =>
  api
    .get('/v1/alerts', {
      params: {
        alertRuleId,
        status: 'Unresolved',
        results: 1,
      },
    })
    .then(
      ({ data }) => unresolvedAlertsResponseSchema.parse(data).totalResults > 0,
    )
